import { CartItem as CartItemType } from '@/types/cart';

import CartItem from './CartItem';

interface CartItemListProps {
  cartItems: CartItemType[];
  getMaxQuantity: (item: CartItemType) => number;
  onUpdateQuantity: (id: string, change: number) => void;
}

export default function CartItemList({ cartItems, getMaxQuantity, onUpdateQuantity }: CartItemListProps) {
  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  return (
    <>
      {/* 담은 상품 */}
      <div className="px-5 pt-[14px]">
        <h2 className="text-xl font-semibold text-[#1F1F1F] mb-6">담은 상품</h2>

        {/* 상품 리스트 */}
        {cartItems.length === 0 ? (
          <div className="py-10 text-center">
            <p className="text-[#868B93] text-base">장바구니가 비어있습니다.</p>
          </div>
        ) : (
          <div className="space-y-0">
            {cartItems.map(item => (
              <CartItem
                key={item.id}
                item={item}
                maxQuantity={getMaxQuantity(item)}
                onUpdateQuantity={onUpdateQuantity}
              />
            ))}
          </div>
        )}

        {/* 합계 - 상품이 있을 때만 표시 */}
        {cartItems.length > 0 && (
          <div className="py-4 bg-white">
            <div className="flex justify-between items-end">
              <span className="text-xl font-semibold text-[#1F1F1F]">합계</span>
              <div className="flex items-center gap-[2px]">
                <span className="text-lg font-semibold text-[#454545]">{getTotalPrice().toLocaleString()}</span>
                <span className="text-base font-semibold text-[#454545]">원</span>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="w-full h-[6px] bg-[#F0F0F0]" />
    </>
  );
}
